import { InvestmentObjective } from './investment-objectiv';

export class Investment {
    preservationofCapital: boolean;
    speculation: boolean;
    tradingProfits: boolean;
    growth: boolean;
    income: boolean;
    hedging: boolean;

    stocks: InvestmentObjective = new InvestmentObjective();
    bonds: InvestmentObjective = new InvestmentObjective();
    warrants: InvestmentObjective = new InvestmentObjective();
    options: InvestmentObjective = new InvestmentObjective();
    futures: InvestmentObjective = new InvestmentObjective();
    futuresOptions: InvestmentObjective = new InvestmentObjective();
    currensyConversion: InvestmentObjective = new InvestmentObjective();
}
